import { Component, Input, EventEmitter, Output, ViewChild } from '@angular/core';
import { RpaConnectorDetail } from 'app/rpa-bots/core/rpa-details-details.types';
import { GetVersionAutomationAnywhere } from '../../automation-anywhere/store/actions/rpa-automation-anywhere-conn.actions';
import { getVersionCurrentAutomationAnywhere} from '../../automation-anywhere/store/selectors/rpa-automation-anywhere-conn.selector';
import { NgForm } from '@angular/forms';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { IAppState } from 'app/IAppState';
import { IRpaConnectionAutomationAnywhere, IRpaConnectionUiPath } from 'app/rpa-bots/core/IRpaBots';

@Component({
    selector: 'bot-configuration',
    templateUrl: 'bot-configuration.component.html',
    styleUrls: ['bot-configuration.component.scss']
})
export class BotConfigurationComponent {
    @Input()
    public get botDetail(): RpaConnectorDetail {
        return this._botDetailData;
    }


    public set botDetail(value: RpaConnectorDetail) {
        this._botDetailData = value;
        this._originalConnector = _.cloneDeep(this._botDetailData);
    }

    get hasChanges(): boolean {
        return !_.isEqual(this._originalConnector, this._botDetailData);
    }
    private _botDetailData: RpaConnectorDetail;
    private _originalConnector: RpaConnectorDetail;
    public chartsVisible: boolean;
    public retriesVisible: boolean;
    public URL_REGEXP = /^((((https?|ftps?):\/\/))(%[0-9A-Fa-f]{2}|[-()_.!~*';\/?:@&=+$,A-Za-z0-9])+)([).!';\/?:,][[:blank:]])?$/;
    automationAnywhereVersion$: Observable<string>;
    automationAnywhereVersionSub: any;

    @Output() save = new EventEmitter<any>();
    @Output() testConnection = new EventEmitter<any>();
    @Input() type: string;

    @ViewChild('botConfigForm', { static: false}) botConfigForm: NgForm;
    public botDetailData: IRpaConnectionUiPath | IRpaConnectionAutomationAnywhere;
    constructor(private _store: Store<IAppState>) {
    }

    ngAfterViewChecked(): void {
        if (!this.botConfigForm.valid) {
            _.each(this.botConfigForm.controls, (ctrl) => {
                if (!ctrl.valid) {
                    ctrl.markAsTouched();
                }
            });
        }
    }

    onClearAll() {
        this._botDetailData.server = '';
        this._botDetailData.password = '';
        if ((this._botDetailData as IRpaConnectionUiPath)) {
            (this._botDetailData as IRpaConnectionUiPath).tenancyName = '';
            (this._botDetailData as IRpaConnectionUiPath).userNameOrEmailAddress = '';
        }
        if ((this._botDetailData as IRpaConnectionAutomationAnywhere)) {
            (this._botDetailData as IRpaConnectionAutomationAnywhere).username = '';
            (this._botDetailData as IRpaConnectionAutomationAnywhere).displayName = '';
        }
        this.botConfigForm.reset();
    }

    isValid(): boolean {
        if(this.botDetail.server == this._originalConnector.server){
            this.botDetail.version = this._originalConnector.version;
        }else{
            this.botDetail.version = "";
        }
        return !this.botConfigForm || this.botConfigForm.valid;
    }

    onTestConnection() {
        this.testConnection.emit();
        this._store.dispatch(new GetVersionAutomationAnywhere(this.botDetail as IRpaConnectionAutomationAnywhere));
        this.automationAnywhereVersion$ = this._store.pipe(select(getVersionCurrentAutomationAnywhere));
        this.automationAnywhereVersionSub = this.automationAnywhereVersion$.subscribe((version) => {
            if(version) {
                this._botDetailData.version =  version;
                if (this.automationAnywhereVersionSub) {
                    this.automationAnywhereVersionSub.unsubscribe();
                }
            }
        });
    }

    onSave() {
        this.save.emit(this._botDetailData);
    }

    showCharts() {
        this.chartsVisible = true;
        this.retriesVisible = false;
    }

    showRetries() {
        this.retriesVisible = true;
        this.chartsVisible = false;
    }

    closeCharts() {
        this.chartsVisible = false;
    }

    closeRetries() {
        this.retriesVisible = false;
    }
}
